import './depot_switcher_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['options', 'abbreviation']
  static classes = ['visible']

  showFloatingLabel = (event: Event): void => {
    this.floatingLabelController.show(this.label)
  }

  hideFloatingLabel = (event: Event): void => {
    this.floatingLabelController.hide()
  }

  updateFloatingLabel = (event: Event): void => {
    this.floatingLabelController.update(event)
  }

  toggle = (event: Event): void => {
    this.visible ? this.close(event) : this.open()
  }

  open = (): void => {
    this.optionsTarget.classList.add(this.visibleClass)
  }

  close = (event: Event): boolean => {
    this.optionsTarget.classList.remove(this.visibleClass)
  }

  closeFromOutside = (event: Event): void => {
    if (event.target === this.abbreviationTarget || event.target.closest('.depot_switcher-options') !== null) return
    this.close()
  }

  get floatingLabelController (): object {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('floating_label'), 'floating-label')
  }

  get label (): string {
    return 'Switch depot'
  }

  get visible (): boolean {
    return this.optionsTarget.classList.contains(this.visibleClass)
  }
}
